module.exports = __webpack_public_path__ + "img/settings1.26b50128.png";